<template>
  <div class="additional">
    <div id="heading">
      <div class="header-icon fa fa-plus-circle"></div>
      <h1>Additional Insurance Services</h1>
    </div>
    <section id="main" class="wrapper">
      <div class="inner">
        <div class="content">
          <div class="text-center">
            <h2>Extra Coverage for Your Specific Needs</h2>
          </div>

          <p>At SIG & Associates, we’re dedicated to delivering the quality products and services you deserve. In
            addition to covering all your primary insurance needs, we can offer other useful services and specialty
            insurance for your convenience. Contact us today and experience how we can go the extra mile for you with
            services such as:</p>

          <ul>
            <li class="list-item link" @click="handleModal()" data-page="wedding">
              Wedding Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="special">
              Special Event Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="other">
              Notary Services
            </li>
            <li class="list-item link" @click="handleModal()" data-page="other">
              License Services
            </li>
            <li class="list-item link" @click="handleModal()" data-page="other">
              Permit Services
            </li>
          </ul>

          <p>Convenience and trust: it’s what you should expect from your insurance agency. At SIG & Associates, we think
          life should be easier, and we are proud to offer our extended services to our valued customers.</p>

          <p>We proudly serve Wichita Falls, Haslet, Decatur, Prosper, Vernon, and Garland.</p>
        </div>
        <hr>
        <div class="content">
          <GetQuoteForm class="get-quote"/>
        </div>
        <hr>
      </div>
    </section>
    <modal v-if="showModal" @close="showModal = false" v-bind:header="modalHeader" v-bind:body="modalBody"/>
  </div>
</template>

<script>
import Vue from 'vue'

import Modal from '@/widgets/Modal'
import GetQuoteForm from '@/components/GetQuoteForm'

import additionalHelper from '../helpers/additionalHelper.js'

Object.defineProperty(Vue.prototype, '$additionalHelper', {value: additionalHelper})
Vue.component('modal')

export default {
  name: 'Additional Insurance Services',
  methods: {
    handleModal: function () {
      let action = event.target.attributes['data-page'].value

      this.modalHeader = this.templates[action].header
      this.modalBody = this.templates[action].body

      this.showModal = true
    }
  },
  data: function () {
    return {
      showModal: false,
      modalHeader: '',
      modalBody: '',
      templates: this.$additionalHelper
    }
  },
  components: {
    Modal,
    GetQuoteForm
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}

.list-item.link {
  cursor: pointer;
  padding: 10px;
}

.list-item.link:hover {
  text-decoration: underline;
}
</style>




// WEBPACK FOOTER //
// src/components/Additional.vue